import React from "react";
export const ErrorList = ({ errors }) => (
  <div className="errors-container">
    <ul>
      {errors?.map((error, idx) => (
        <li key={idx}>{error}</li>
      ))}
    </ul>
  </div>
);
